<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="errorMessage" class="info-alert row-space">{{ errorMessage }}</div>


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Protocolo</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.id) }}</div>
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Data/Hora</label>
                <div class="field-label field-label-center">
                    {{ Funcoes.formatDateFromJson(objView.dtvistoria) }}
                    {{ objView.hrvistoria }}
                </div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">KM/Horas</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.kmhoras) }}</div>
            </div>

            <div class="form-item ">
                <label class="label-caption">Equipamento/Veículo</label>
                <div class="field-label">{{ objView.nmequipamento }}</div>
            </div>

            <div class="form-item-char40">
                <label class="label-caption">Equipamento/Veículo</label>
                <div class="field-label">{{ objView.nmgrupo }}</div>
            </div>
        </div>


        <div class="row">
            <div class="form-item">
                <label class="label-caption">Operador Responsável</label>
                <div class="field-label">{{ objView.nmoperador }}</div>
            </div>

            <div class="row-end">
                <button class="btn-small" @click="imprimirLaudo">Laudo</button>
                <button v-if="lsAnexos.length>0" class="btn-small" @click="abrirFotos">Fotos ({{ lsAnexos.length }})</button>
                <button class="btn-small" @click="closeForm">Retornar</button>
            </div>
        </div>
    </div>


    <div class="form-panel">
        <div class="form-panel-header">ITENS VARIFICADOS</div>
        <div v-if="lsItens.length>0">
            <table>
                <thead><tr>
                    <th>Ordem</th>
                    <th>Item</th>
                    <th>Resultado</th>
                </tr></thead>
                <tbody>
                    <tr v-for="(obj, index) in lsItens" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                        <td class="col-width-integer right">{{ obj.ordem }}</td>
                        <td>{{ obj.nmitem }}</td>
                        <td class="col-width-char40 center">{{ obj.resposta_bool }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    
    <div v-if="modalFotosAberto" class="modal-overlay">
        <div class="photos-modal">
            <div class="modal-header">
                <h3>Fotos do checklist</h3>
                <button class="btn-small" @click="modalFotosAberto = false">FECHAR</button>
            </div>

            <div v-if="loadingFotos" class="photos-loading">
                Carregando fotos...
            </div>

            <div v-else class="photos-grid">
                <img
                    v-for="(foto, index) in fotosCarregadas"
                    :key="foto.idanexo"
                    :src="foto.url"
                    class="photo-thumb"
                    :class="{ 'photo-thumb-active': index === fotoAtualIndex }"
                    @click="fotoAtualIndex = index"
                />
            </div>

            <div v-if="fotosCarregadas[fotoAtualIndex]" class="photo-preview">
                <img :src="fotosCarregadas[fotoAtualIndex].url" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});

const errorMessage = ref(null);
const isLoading = ref(false);
const lsAnexos = ref([]);
const lsItens = ref([]);
const objView = ref({});

const modalFotosAberto = ref(false);
const loadingFotos = ref(false);
const fotosCarregadas = ref([]);
const fotoAtualIndex = ref(0);


async function abrirFotos(){
    modalFotosAberto.value = true;
    if (fotosCarregadas.value.length>0) return;
    loadingFotos.value = true;

    try{
        for (const anexo of lsAnexos.value){
            if (anexo.storage_cdtipo === 2 && anexo.storage_status === 1) {
                const rUrl = await Api.genericPost('/main/solicitar/download', {
                    id: anexo.idanexo
                });

                if (rUrl.bolok === 1) {
                    fotosCarregadas.value.push({
                        ...anexo,
                        url: rUrl.download_url,
                        nome: rUrl.nome_arquivo
                    });
                }
            }
        }
        fotoAtualIndex.value = 0;
    } catch (error) {
        errorMessage.value = `ATENÇÃO: ${error.message}`;
    } finally {
        loadingFotos.value = false;
    }
}


const closeForm = () => {
    emit('close'); 
}


async function imprimirLaudo(){
    try{
        errorMessage.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: 'checklist_laudo',
            idmunicipio: globalStore.idmunicipio,
            id: props.idView,
            idusuario: globalStore.idusuario,
            idlogin: globalStore.idlogin};
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function lerDados() {
    try{
        isLoading.value = true;
        const req = await Api.genericPost('/dados/checklist', {
            idmunicipio: globalStore.idmunicipio,
            id: props.idView});

        if (req.length > 0){
            Object.assign(objView.value, req[0]);
            const an = await Api.genericPost('/dados/checklist/anexo', {
                idmunicipio: globalStore.idmunicipio,
                idreferencia: props.idView});
            lsAnexos.value = an;
            
            const itens = await Api.genericPost('/dados/checklist/item', {
                idmunicipio: globalStore.idmunicipio,
                idreferencia: props.idView});
            lsItens.value = itens;
        }
    }catch (error){alert(error);
    }finally{isLoading.value = false;}
}


onMounted(lerDados);
</script>


<style scoped>
.modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 1999;
    background: rgba(15, 23, 42, 0.55);
    display: flex;
    justify-content: center;
    align-items: center;
}

.photos-modal {
    width: min(1000px, 94vw);
    max-height: 90vh;
    overflow: auto;
    background: #fff;
    border-radius: 10px;
    padding: 16px;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
}

.photos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 10px;
    margin-bottom: 16px;
}

.photo-thumb {
    width: 100%;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
    border: 2px solid #e2e8f0;
    cursor: pointer;
}

.photo-thumb-active {
    border-color: #2563eb;
}

.photo-preview {
    text-align: center;
}

.photo-preview img {
    max-width: 100%;
    max-height: 65vh;
    object-fit: contain;
    border-radius: 8px;
}
</style>